<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Stall / Catalogue</div>
</div>


<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="so_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID.</th>
                <td mat-cell *matCellDef="let element"> {{element.so_id}} </td>
            </ng-container>

            <ng-container matColumnDef="company_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Company Name </th>
                <td mat-cell *matCellDef="let element">{{element.company_name}}</td>
            </ng-container>

            <ng-container matColumnDef="owner_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Owner Name </th>
                <td mat-cell *matCellDef="let element">{{element.owner_name}}</td>
            </ng-container>

            <ng-container matColumnDef="owner_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </th>
                <td mat-cell *matCellDef="let element">{{element.owner_number}}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let element">{{element.type}}</td>
            </ng-container>
            <ng-container matColumnDef="product_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Products </th>
                <td mat-cell *matCellDef="let element">{{element.product_count}}</td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button matTooltip="Navigate to Event Admin"
                        style="margin-right: 5px;background: green;color: white;" (click)="Go(element.owner_number)">
                        Go
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>